module.exports = __webpack_public_path__ + "static/media/empty-cart.4a1f4407.svg";